import React from 'react';
import { Counter as CounterInput } from '@cp/ds/src/components/counter';
import { CounterProps as CounterInputProps } from '@cp/ds/src/components/counter/model';
import { useWatch } from 'react-hook-form';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { CATALOG_ITEM_TARIFFS_COUNT_MAX, CATALOG_ITEM_TARIFFS_COUNT_MIN } from '@common/const/catalog/item';
import { useDeclination } from '@cp/shared/declination';
import { TariffsEditFormModel } from '../model';
import { CounterProps } from './model';

export const Counter: React.FC<CounterProps> = ({ form }) => {
  const declination = useDeclination();
  // Reason to use 'useWatch' and 'getValues' together:
  // https://github.com/react-hook-form/react-hook-form/issues/2738
  useWatch<TariffsEditFormModel, 'tariffs'>({ name: 'tariffs' });
  const tariffs = form.getValues('tariffs') ?? [];

  const handleChange: CounterInputProps['onChange'] = (newCount) => {
    const newTariffs = [
      ...tariffs.slice(0, newCount),
      ...(tariffs.length < newCount
        ? Array.from(new Array(newCount - tariffs.length), (_, index) => ({ childrenCount: index + tariffs.length + 1, price: 0 }))
        : []),
    ];
    form.setValue('tariffs', newTariffs);
  };

  const count = tariffs.length;

  return (
    <CounterInput
      label="Максимальное количество детей"
      max={CATALOG_ITEM_TARIFFS_COUNT_MAX}
      min={CATALOG_ITEM_TARIFFS_COUNT_MIN}
      onChange={handleChange}
      subjectLabel={declination(count, DeclinationMnemonic.Child)}
      value={count}
    />
  );
};
